import { observable } from 'mobx';
import { App, ArrayApp, Model, ModelRegistry, AppRegistry } from 'core';

export class MessageModel extends Model {
  static registryName = 'MessageModel';
  static ModelProps = {
    lastMessage: 'MessageModel',
    createdBy: 'UserModel',
    asSpace: 'SpaceModel',
  };

  @observable id;
  @observable messageType;
  @observable body;
  @observable snippet;
  @observable referenceId;
  @observable resourceId;
  @observable tempKey;
  @observable updatedAt;
  @observable timestamp;

  @observable createdBy = null;
}
ModelRegistry.add(MessageModel);

export class ConversationModel extends Model {
  static registryName = 'ConversationModel';
  static ModelProps = {
    lastMessage: 'MessageModel',
    // lastReadMessage: 'MessageModel',
    // messages: ['MessageModel'],
  };

  @observable lastUpdatedAt;
  @observable id;
  @observable uri;
  @observable contextId;
  @observable resourceId;
  @observable type;
  @observable unreadCount = 0;
  @observable lastMessage = null;
  @observable context = null;
}
ModelRegistry.add(ConversationModel);

export class ConversationApp extends App {
  static registryName = 'ConversationApp';
  static Model = ConversationModel;
  static AppProps = {
    childMaterials: 'MaterialsApp',
    parentMaterial: 'MaterialApp',
  };
}
AppRegistry.add(ConversationApp);

export class ConversationsApp extends ArrayApp {
  static registryName = 'ConversationsApp';
  static ElementApp = ConversationApp;
}
AppRegistry.add(ConversationsApp);
